import type { ReactNode } from 'react';

export const symbol_123: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-552h-36q-10 0-17-7t-7-17q0-10 7-17t17-7h60q10 0 17 7t7 17v192q0 10-7 17t-17 7q-10 0-17-7t-7-17v-168Zm132 168v-86q0-15 9.5-24.5T386-504h98v-48H376q-10 0-17-7t-7-17q0-10 7-17t17-7h122q15 0 24.5 9.5T532-566v76q0 15-9.5 24.5T498-456h-98v48h108q10 0 17 7t7 17q0 10-7 17t-17 7H376q-10 0-17-7t-7-17Zm394 24H624q-10 0-17-7t-7-17q0-10 7-17t17-7h108v-48h-68q-10 0-17-7t-7-17q0-10 7-17t17-7h68v-48H624q-10 0-17-7t-7-17q0-10 7-17t17-7h122q15 0 24.5 9.5T780-566v172q0 15-9.5 24.5T746-360Z"
		/>
	</svg>
);
